var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00292969 5.63333V11.2667H7.50293H15.0029V5.63333V0H7.50293H0.00292969V5.63333ZM13.2689 1.05C13.2686 1.07753 12.0459 2.32247 10.5518 3.81667L7.83533 6.53333H7.53886H7.2424L5.58426 4.88333C4.67233 3.9758 3.44493 2.73087 2.8568 2.11667L1.7874 1H7.52853C10.6861 1 13.2693 1.02247 13.2689 1.05ZM3.36593 4.11327L4.82046 5.59327L4.63586 5.81327C4.53433 5.93433 3.6904 6.80747 2.76046 7.7536L1.0696 9.47393V5.62093V1.76793L1.49053 2.2006C1.722 2.4386 2.566 3.29933 3.36593 4.11327ZM13.9206 7.55353L13.9029 9.4404L12.0484 7.54273L10.1938 5.645L12.0484 3.77253L13.9029 1.9L13.9206 3.78333C13.9303 4.81913 13.9303 6.51573 13.9206 7.55353ZM6.1032 6.86693C6.64326 7.41113 6.9772 7.56893 7.5696 7.55973C8.12233 7.5512 8.40386 7.41087 8.9704 6.86153L9.45853 6.3882L11.0861 8.04407C11.9813 8.95487 12.8272 9.82747 12.9661 9.98333L13.2185 10.2667H7.50506H1.79173L2.16786 9.85C2.81706 9.13087 5.4996 6.41893 5.5714 6.40927C5.60906 6.40413 5.84833 6.61013 6.1032 6.86693Z",
    fill: "#012433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.89e6b4aece8c983cdf56da6fc4b94a24.svg";
export { ForwardRef as ReactComponent };